import { render, staticRenderFns } from "./SignUpNavBar.vue?vue&type=template&id=d460ab66&"
import script from "./SignUpNavBar.vue?vue&type=script&lang=js&"
export * from "./SignUpNavBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports